module.exports = __webpack_public_path__ + "img/7.1d6b5557.jpg";